import { Row, Col } from "../../App.styles";
import { Switch } from "../../common";

const VisibilitySection = ({ useQuery }) => {
  const { hide_answers } = useQuery();

  return (
    <Row>
      <Col>
        <p>Show submissions in streams:</p>
        <Switch
          labels={{ on: "Show", off: "Hide" }}
          on={0}
          off={1}
          value={hide_answers}
          name="hide_answers"
          useQuery={() => [{ hide_answers }, () => null]}
        />
      </Col>
    </Row>
  );
};

export default VisibilitySection;
